var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-box',{attrs:{"options":_vm.availableLanguages,"clearable":false,"searchable":false,"label":"name"},model:{value:(_vm.currentLanguage),callback:function ($$v) {_vm.currentLanguage=$$v},expression:"currentLanguage"}})}
var staticRenderFns = []

export { render, staticRenderFns }